import React from 'react'
import { useState, useContext } from "react"
import firebase from "firebase";
import { Context } from "../Context/GlobalState";
import CircularProgress from "@material-ui/core/CircularProgress";
import ScholarDataService from "../services/ScholarService";


function AddScholar() {
    const { user } = useContext(
        Context
      );
    const initialScholarState = {
        nickname: "",
        ethereumAddress: ""
    };
    const [scholar, setScholar] = useState(initialScholarState);
    const [isLoading, setIsLoading] = useState(false); 

    const handleInputChange = e => {
        const { name, value } = e.target;

        setScholar({ ...scholar, [name]: value });
    };

    const newScholar = () => {
        setIsLoading(true);
        var data = {
            nickname: scholar.nickname,
            ethereumAddress: scholar.ethereumAddress,
            totalSlp: "",
            claimable: "",
            lastClaimed: "",
            claimableOn: "",
            team: user.team,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        };
        ScholarDataService.create(data)
            .then(() => {
                setIsLoading(false);
            })
            .catch(e => {
            console.log(e);
        });
    };
    
    return (
        <div className="scholars__wrapper">
            <div className="scholars__container">

                <div className="input__wrapper">
                    <div className="input__fields">
                        <div className="form__field">
                            <input
                                type="text"
                                id="nickname"
                                name="nickname"
                                placeholder="Nickname"
                                value={scholar.nickname}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form__field">
                            <input
                                type="text"
                                id="ethereumAddress"
                                name="ethereumAddress"
                                placeholder="Ethereum Address"
                                value={scholar.ethereumAddress}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>                    
                    <div className="action-button">
                        <button className="primary-btn" onClick={newScholar} disabled={isLoading}>
                        {!isLoading ? (
                            "Add Scholar"
                            ) : (
                                <CircularProgress size={20} color="inherit" />
                                )}
                        </button>
                    </div>
                </div>
            </div>
        </div>    
    );
}

export default AddScholar
